import { render, staticRenderFns } from "./AddEditReturnModal.vue?vue&type=template&id=23152014&scoped=true"
import script from "./AddEditReturnModal.vue?vue&type=script&lang=js"
export * from "./AddEditReturnModal.vue?vue&type=script&lang=js"
import style0 from "./AddEditReturnModal.vue?vue&type=style&index=0&id=23152014&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23152014",
  null
  
)

export default component.exports